<template>
  <div>
    <div style="padding:0px 0px 0px 0px;font-size:18px;">Opportunities Due Today ({{openCount}})</div>
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 430
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    opportunityData: {
      type: Object,
      default: () => {}
    },
    openCount: {
      type: Number,
      default: 0
    }
  },
watch: {
  opportunityData: function() {
    this.chartData.datasets = [
      {
        label: 'Opportunities Due Today',
        backgroundColor: '#c92127',
        data: this.opportunityData
      }
    ]
  }
},
  data() {
    return {
      chartData: {
        datasets: [
          {
            label: 'Opportunities Due Today',
            backgroundColor: '#c92127',
            data: this.opportunityData
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        ticks: {
          precision:0
        },
        plugins: {
          tooltip: {
            enabled: true // <-- this option disables tooltips
          },
          legend: {
            display: false
          }
        }
      }
    }
  }
}
</script>
